import type React from 'react';

/** A left click with no modifier key - the click that navigates in place. */
export const isPlainClick = (event: React.MouseEvent) =>
  event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;

/**
 * The click handler of a real link (`<a href>`) that still navigates in the
 * app: a plain click runs `navigate`, anything else - ctrl/cmd or middle click,
 * the context menu's "open in new tab" - is left to the browser and the href.
 */
export const inAppClick =
  (navigate: () => void) =>
  (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (!isPlainClick(event)) return;
    event.preventDefault();
    navigate();
  };

/**
 * The click handler of a link inside a clickable row or cell that already
 * navigates: a plain click is left to bubble up to it, anything else goes to
 * the browser. The row's own handler must ignore non-plain clicks.
 */
export const linkInClickableParent = (event: React.MouseEvent<HTMLAnchorElement>) => {
  if (isPlainClick(event)) event.preventDefault();
};
